<div class="password-reset">
  <authentication-wrapper>
    <article class="password-reset__content-wrapper">
      <div class="form__header">
        <h2 class="form__title">Récupération de mot de passe</h2>
      </div>
      <password-reset-stepper></password-reset-stepper>
    </article>
  </authentication-wrapper>
</div>
